import { createFileRoute } from '@tanstack/react-router'

import { TaskLayout } from '@/components/view/task/task-layout'

export const Route = createFileRoute('/(app)/track/$trackid/speaking/$quizid')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TaskLayout></TaskLayout>
}

// function Breadcrumbs() {
//   const { track, quiz } = useData()

//   return (
//     <TaskLayoutBreadcrumbs
//       items={[
//         ['Kelas', linkOptions({ from: Route.fullPath, to: '/' })],
//         [
//           track.getDetailTrack.title,
//           linkOptions({ from: Route.fullPath, to: '/track/$trackid' }),
//         ],
//         [quiz.quiz_chapter[0]!.chapter.title!, Route.fullPath],
//       ]}
//     />
//   )
// }
